
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ImageData } from "./types";

export const usePassionImages = () => {
  const { data: imagesActivities, refetch: refetchActivities } = useQuery<ImageData[]>({
    queryKey: ["images", "passions", "activities"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "passions")
        .eq("subsection", "passions-activities")
        .order('created_at', { ascending: true });
      
      if (error) {
        console.error("Error fetching activities gallery:", error);
        return [];
      }
      console.log("Activities images:", data?.map((img, index) => ({
        number: index + 1,
        id: img.id,
        path: img.storage_path
      })));
      return data || [];
    },
  });

  const { data: imagesSongs, refetch: refetchSongs } = useQuery<ImageData[]>({
    queryKey: ["images", "passions", "songs"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "passions")
        .eq("subsection", "passions-songs")
        .order('created_at', { ascending: true });
      
      if (error) {
        console.error("Error fetching songs gallery:", error);
        return [];
      }
      console.log("Songs images:", data?.map((img, index) => ({
        number: index + 1,
        id: img.id,
        path: img.storage_path
      })));
      return data || [];
    },
  });

  const refetchAll = () => {
    refetchActivities();
    refetchSongs();
  };

  return {
    imagesActivities,
    imagesSongs,
    refetchAll
  };
};
